import type { NavigateOptions, RegisteredRouter } from '@tanstack/react-router';

let routerInstance: RegisteredRouter | null = null;

export function setRouterInstance(router: RegisteredRouter) {
  routerInstance = router;
}

export function isInAuthGatedRoute(): boolean {
  return (
    routerInstance?.state.matches.some(
      (match) => match.staticData.requiresAuth
    ) ?? false
  );
}

export function preloadRoute<T extends string = string>(
  options: NavigateOptions<RegisteredRouter, string, T>
) {
  return routerInstance?.preloadRoute(options);
}

export function navigate<T extends string = string>(
  options: NavigateOptions<RegisteredRouter, string, T>
) {
  if (!routerInstance) {
    console.error(
      '[navigation-service] Router not initialized, skipping navigation:',
      options
    );
    return;
  }
  return routerInstance.navigate(options);
}
